import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

const Heading = ({ as= "h2", subHeading, heading }) => {
  const Component = as;

  return (
    <Container>
      <Row>
        <Col xs={12}>
          {subHeading ? (
            <p className='sub-heading'>
              <small>{subHeading}</small>
            </p>
          ) : null}
          <Component className='heading'>{heading}</Component>
          <hr className='ruler' />
        </Col>
      </Row>
    </Container>
  );
};

export default Heading;

Heading.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};
